import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CompagnieComponent } from './compagnie.component';
import { CompagnieFormComponent } from './dialogs/form/form.component';


const routes: Routes = [
  {
    path: '', component: CompagnieComponent
  },
  {
    path: 'inserisci', component: CompagnieFormComponent,
    data: { title: 'Inserimento Compagnie' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CompagnieRoutingModule { }
